const invitationPreviewModal = {
  header: "Forskoða og breyta boðspósti",
  envelope: {
    from: "Frá:",
    to: "Til:",
    cc: "Afrit:",
    subject: "Efni:",
    ccNotice: "(þú færð afrit)",
  },
  body: {
    greetingWithName: "Sæl/sæll {{name}},",
    greetingWithEmail: "Sæl/sæll {{email}},",
    project:
      "Þér hefur verið boðið að taka þátt í rannsóknarverkefni.\n\nVerkefni: {{project}}\nBoðið af: {{inviter}}\n\nSmelltu á hlekkinn hér fyrir neðan til að samþykkja boðið og fá aðgang að verkefninu.",
    redirect:
      "{{inviter}} hefur framsent þér gagnabeiðni og óskar eftir aðstoð þinni.\n\nHeiti beiðni: {{title}}\n\nVinsamlegast farðu yfir beiðnina og svaraðu eins fljótt og auðið er.",
    uploader:
      "Þér hefur verið boðið að hlaða upp gögnum fyrir rannsóknarverkefni.\n\n{{inviter}} óskar eftir gögnum fyrir verkefnið {{project}}.\n\nVinsamlegast notaðu hlekkinn hér fyrir neðan til að hlaða gögnunum upp á öruggan hátt. ",
  },
  subject: {
    project: "Þér hefur verið boðið í verkefnið: {{project}}",
    redirect: "Gagnabeiðni framsend til þín",
    uploaderWithProject: "Beiðni um gagnaupphleðslu: {{project}}",
    uploaderNoProject: "Beiðni um gagnaupphleðslu",
  },
  actionLabel: {
    project: "Samþykkja boð",
    redirect: "Skoða beiðni",
    uploader: "Hlaða upp gögnum",
  },
  summary: {
    project: "{{inviter}} bauð þér að taka þátt í '{{project}}'",
    redirect: "{{inviter}} framsendi gagnabeiðni: '{{title}}'",
    uploaderWithProject: "{{inviter}} óskar eftir gögnum fyrir verkefnið '{{project}}'",
    uploaderNoProject: "{{inviter}} óskar eftir gögnum fyrir rannsóknarverkefni",
  },
  editableBodyLabel: "Meginmál pósts — breyta að vild",
  footer: {
    serviceName: "Nafnleyndarkerfi — Örugg dulnefning rannsóknargagna",
    automatedNotice: "Þetta er sjálfvirk tilkynning. Vinsamlegast svarið ekki þessum pósti.",
  },
  resetToDefault: "Endurstilla á sjálfgefið",
  sendButton: "Senda boð",
};

export default invitationPreviewModal;
